import React from 'react';
import { OFFICIAL_TIMEZONES } from '../../../../utilities/BL/Admin/Reports';

/**
 * Componente selector de zona horaria para el módulo de reportes.
 * Muestra un dropdown con las plazas y husos horarios oficiales de los estadios,
 * y un indicador visual si la zona seleccionada coincide con la autodetectada por el navegador.
 *
 * @param {Object} props
 * @param {string} props.currentTimezone - Identificador IANA de la zona actual (ej. 'America/Mexico_City')
 * @param {Function} props.onChangeTimezone - Callback ejecutado al cambiar de zona horaria
 * @param {string} [props.detectedTimezone] - Zona horaria autodetectada por el cliente
 * @param {boolean} [props.disabled=false] - Si el selector está inhabilitado
 */
export default function TimezoneSelector({
  currentTimezone,
  onChangeTimezone,
  detectedTimezone,
  disabled = false,
}) {
  const isDetected = Boolean(detectedTimezone && currentTimezone === detectedTimezone);

  return (
    <div className="AdmReports__TimezoneSelector">
      <div className="AdmReports__TimezoneLabel">
        <i className="bi bi-clock-history AdmReports__TimezoneIcon" aria-hidden="true"></i>
        <span>Zona Horaria:</span>
        {isDetected && (
          <span
            className="AdmReports__DetectedBadge"
            title={`Zona detectada automáticamente: ${detectedTimezone}`}
          >
            <i className="bi bi-geo-alt-fill me-1" aria-hidden="true"></i>
            Detectada
          </span>
        )}
      </div>

      <div className="AdmReports__SelectWrapper">
        <select
          id="adm-reports-tz-selector"
          className="AdmReports__Select"
          value={currentTimezone}
          onChange={(e) => onChangeTimezone?.(e.target.value)}
          disabled={disabled}
          aria-label="Zona horaria para visualización y exportación de reportes"
        >
          {OFFICIAL_TIMEZONES.map((tz) => (
            <option key={tz.value} value={tz.value}>
              {tz.label}
            </option>
          ))}
        </select>
        <i className="bi bi-chevron-down AdmReports__SelectArrow" aria-hidden="true"></i>
      </div>
    </div>
  );
}

export { TimezoneSelector };
